import React, { useEffect } from "react";
import NavbarEnlaces from "../../../layout/NavbarEnlaces";
import Accordion from "../../../layout/Accordion/Accordion";
import AccordionItem from "../../../layout/Accordion/AccordionItem";
import { dataAcuerdosOIC } from "../../../data/dataOIC";

export const AcuerdosOIC = () => {
  useEffect(() => {
    document.title = "Acuerdos OIC";
  }, []);

  return (
    <div className="margin-bottom-2">
      <NavbarEnlaces title="Órgano Interno de Control - Acuerdos" />

      <Accordion idAccordion="acuerdosOIC">
        {dataAcuerdosOIC.map((item) => (
          <AccordionItem
            key={item.id}
            flushID={`acuerdo-${item.id}`}
            titleItem={item.titleItem}
            idAccordion="acuerdosOIC"
            contentItem={
              <div className="w-75 mx-auto mb-3">

                {/* DOCUMENTO PRINCIPAL */}
                <ul className="list-group mb-3">

                  <li className="list-group-item d-flex justify-content-between align-items-center">

                    <span>
                      <i className="fa fa-file-pdf text-danger me-2"></i>
                      {item.titleItem}
                    </span>

                    <a
                      href={item.linkItem}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-outline-danger btn-sm"
                    >
                      <i className="fa fa-eye me-1"></i>
                      Abrir
                    </a>

                  </li>

                </ul>

                {/* SUBDOCUMENTOS */}
                {item.subDocuments &&
                  item.subDocuments.length > 0 && (

                  <ul className="list-group">

                    {item.subDocuments.map((doc) => (

                      <li
                        key={doc.id}
                        className="list-group-item d-flex justify-content-between align-items-center"
                      >

                        <span>

                          {doc.typeDocument === "pdf" && (
                            <i className="fa fa-file-pdf text-danger me-2"></i>
                          )}

                          {doc.typeDocument === "excel" && (
                            <i className="fa fa-file-excel text-success me-2"></i>
                          )}

                          {doc.title}

                        </span>

                        <a
                          href={doc.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-outline-secondary btn-sm"
                        >
                          <i className="fa fa-eye me-1"></i>
                          Abrir
                        </a>

                      </li>

                    ))}

                  </ul>

                )}

              </div>
            }
          />
        ))}
      </Accordion>
    </div>
  );
};

export default AcuerdosOIC;